/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import {dataurl} from '../components/paksh-constants.js'

const initialState = {
  isFetching: false,
  failure: false,
  items: {},
  query : ""
};

export const judgesSelector = state => state.judges && state.judges.items;

export const judgeListSelector = createSelector(
  judgesSelector,
//  (items) => items ? Object.keys(items).map(key => items[key]) : [{},{},{},{},{}]
  (items) => items ? Object.keys(items).map(key => items[key]) : ""
);


export const searchJudges = (query) => (dispatch, getState) => {
  // Check to see if the cached results are from the same query.
  // This is useful for avoiding a network request.
  console.log("in search judges")
  if (shouldSearchJudges(getState(), query)) {
    dispatch(judgesRequested(query));
    //const state=getState()
      const token = window.localStorage.getItem('token');
      if (query) {
        fetch(`${dataurl}/judges?q=${query}`, {
          method: 'GET',
          headers: {
            'x-access-token': token,
          }
        })
          .then(res => res.json())
          .then(data => dispatch(judgesReceived(data.judges)))
          .catch(() => dispatch(judgesFailed(query)));
        // console.log("fetch judges executed")
      } else {
        // query is empty, clear the results
        // console.log("empty judges query")
        dispatch(judgesReceived());
      }


  }

};

const shouldSearchJudges = (state, query) =>
  // if user is not logged in then dont get judges
  // check state if judges not already available in state or if the query is diff from the query stored
  // in the state and there is no fetching underway then should do new search.
   state.judges.failure || state.judges.query !== query && !state.judges.isFetching



export const judgesSlice = createSlice({
  name: 'judges',
  initialState,
  reducers: {
    judgesRequested(state, action) {
      state.query = action.payload;
      state.items = null; // reset items
      state.failure = false;
      state.isFetching = true;
    },
    judgesReceived(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {}),
      state.failure = false;
      state.isFetching = false;
    },
    judgesFailed(state, action) {
      console.log("in judgesFailed -judgesSlice")
      state.items= null;
      state.failure = true;
      state.isFetching = false;
    },
    judgesUpdated(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {})
    },
  },
})

export const { judgesRequested, judgesReceived, judgesFailed, judgesUpdated } = judgesSlice.actions

// Export the slice reducer as the default export
export default judgesSlice.reducer